import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/img/icons/add-circle.svg'
import _imports_1 from '../../assets/img/icons/tick-circle.svg'


const _hoisted_1 = { class: "main-content bg_gray d-flex flex-column transition overflow-hidden" }
const _hoisted_2 = { class: "row gx-0 mb-30" }
const _hoisted_3 = { class: "col-xxl-5 col-md-6" }
const _hoisted_4 = { class: "filter-left d-flex align-items-center flex-wrap" }
const _hoisted_5 = { class: "bg-white pt-3 pb-3 px-4 d-flex justify-content-between align-items-center w-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainHeader = _resolveComponent("MainHeader")!
  const _component_MainSidebar = _resolveComponent("MainSidebar")!
  const _component_BreadcrumbMenu = _resolveComponent("BreadcrumbMenu")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BackupContent = _resolveComponent("BackupContent")!
  const _component_MainFooter = _resolveComponent("MainFooter")!
  const _component_BackupContentModal = _resolveComponent("BackupContentModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MainHeader),
    _createVNode(_component_MainSidebar),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_BreadcrumbMenu, { pageTitle: "Backup" }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[1] || (_cache[1] = _createElementVNode("h6", { class: "fs-14 text-optional fw-normal mb-0" }, [
                _createTextVNode(" Backup File "),
                _createElementVNode("span", { class: "text-title fw-semibold" }, " Location storage/software/Recent/Backup ")
              ], -1)),
              _createVNode(_component_router_link, {
                to: "/",
                class: "fw-semibold text-purple fs-14 lh-1"
              }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode(" Edit File Location ", -1)
                ]))]),
                _: 1
              })
            ])
          ])
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "col-xxl-7 col-md-6" }, [
          _createElementVNode("div", { class: "filter-right d-flex align-items-center justify-content-md-end flex-wrap" }, [
            _createElementVNode("a", {
              href: "javascript:void(0)",
              class: "btn style-one",
              "data-bs-toggle": "modal",
              "data-bs-target": "#createModal"
            }, [
              _createTextVNode(" Generate Backup "),
              _createElementVNode("img", {
                src: _imports_0,
                alt: "Image"
              })
            ])
          ])
        ], -1))
      ]),
      _createVNode(_component_BackupContent),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1)),
      _createVNode(_component_MainFooter)
    ]),
    _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"delete-popup offcanvas offcanvas-end border-0\" tabindex=\"-1\" id=\"deletePopup\" data-v-2a24f729><div class=\"offcanvas-body p-0\" data-v-2a24f729><div class=\"delete-success\" data-v-2a24f729><img src=\"" + _imports_1 + "\" alt=\"Image\" data-v-2a24f729><span class=\"text-white fw-medium\" data-v-2a24f729> Your product is deleted from the list. </span></div></div></div>", 1)),
    _createVNode(_component_BackupContentModal)
  ], 64))
}